import { Component, Output, EventEmitter, OnInit } from '@angular/core';
// import { State } from '@progress/kendo-data-query';
import { DatasourceService } from '@app/core/services';


@Component({
  selector: 'vehicle-filter',
  template: `
    <!--{{_selected | json}}-->
    <kendo-dropdownbutton [data]="data" textField="text" icon="k-icon k-i-filter">
      <span class="k-icon k-i-{{ _selected.icon }}" style="color: #{{ _selected.color }}"></span> {{ _selected.text }}
      <ng-template kendoDropDownButtonItemTemplate let-dataItem>
        <span class="k-icon k-i-{{ dataItem.icon }}" style="color: #{{ dataItem.color }}"></span>
        <span>{{ dataItem.text }}</span>
      </ng-template>
    </kendo-dropdownbutton>
  `,
})
export class VehicleFilterComponent implements OnInit {

  public _selected!: any;

  public data: Array<any> = [
    {
      id: 0, text: "TODO", icon: "kpi-status-open", color: "95a5a6",
      click: (dataItem: any) => {

        this.change(dataItem);                
  
      },
    }
  ];

  @Output() selected = new EventEmitter<any>();


  constructor(protected service : DatasourceService) { 

    this._selected = this.data[0];

  }
  
  // protected getInitialState() : State {

  //     let s = this.service.getStateEmpty();
  //     s.take = 0;
  //     // s.sort = [      
  //     //     {field: 'sku_exp', dir: 'desc'}
  //     // ];
  //     // s.filter = {
  //     //     logic: "and",
  //     //     filters: []
  //     // }

  //     return s;

  // }

  protected change(dataItem: any) {

    this._selected = dataItem;
    console.log(this._selected);
    this.selected.emit({dataItem: this._selected});

  }

  ngOnInit() { 
  
    let that = this;
    this.service.getAll('vehicles_status', this.service.getStateEmpty(), (table, res)=>{
            
          // console.log(res);
          let all = this.data[0];
          this.data = res.data.map(function (item: any) {
              return {
                id: item.id, text: item.name, icon: "kpi-status-open", color: item.color,
                click: (dataItem: any) => {
    
                  that.change(dataItem);                
            
                }
              }; 
            })
          
          this.data.splice(0, 0, all);

      });

  }

    

}